import { render } from "./pediatrics_investigations.vue?vue&type=template&id=c73386c8&scoped=true"
import script from "./pediatrics_investigations.vue?vue&type=script&lang=js"
export * from "./pediatrics_investigations.vue?vue&type=script&lang=js"

import "./pediatrics_investigations.vue?vue&type=style&index=0&id=c73386c8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73386c8"]])

export default __exports__